import {OperatorType} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator"

type OperatorDescBase = {
    readonly label: string
    readonly icon: string
    readonly description: string
}

export type OperatorDesc = OperatorDescBase & {
    readonly type: OperatorType
}

export const isKnownOperatorType = (type: string): type is OperatorType => type in byOperatorType

export const byOperatorType: Record<OperatorType, OperatorDesc> = {
    "operator-initial": {
        type: "operator-initial",
        label: "Initial",
        icon: "far fa-asterisk",
        description: "Original image.",
    },
    "operator-shift": {
        type: "operator-shift",
        label: "Shift",
        icon: "far fa-arrows",
        description: "Shifts the texture.",
    },
    "operator-rotate": {
        type: "operator-rotate",
        label: "Rotate",
        icon: "far fa-undo",
        description: "Rotates the texture.",
    },
    "operator-layer-and-mask": {
        type: "operator-layer-and-mask",
        label: "Layer and Mask",
        icon: "far fa-draw-polygon",
        description: "A maskable layered copy of the texture.",
    },
    "operator-highpass": {
        type: "operator-highpass",
        label: "Gradient Removal",
        icon: "far fa-wave-sine",
        description: "Removes unwanted gradients from the texture.",
    },
    "operator-recolor": {
        type: "operator-recolor",
        label: "Recolor",
        icon: "far fa-palette",
        description: "Statistically matches the texture's color to target Lab mean/stddev values.",
    },
    "operator-clone-stamp": {
        type: "operator-clone-stamp",
        label: "Clone stamp",
        icon: "far fa-stamp",
        description: "Fill in a region by cloning some other region.",
    },
    "operator-tiling": {
        type: "operator-tiling",
        label: "Tiling",
        icon: "far fa-location-dot",
        description: "Make texture tilable.",
    },
    "operator-test": {
        type: "operator-test",
        label: "Test",
        icon: "far fa-asterisk",
        description: "Test operator.",
    },
}
